<template>
  <div class="div8 cutbox">
 
      <div class="text1" data-id="主标题1" data-range="5,8">
        {{ info.titles[0] }}
      </div>
      <div class="text2">
        <span data-id="短特点1" data-range="4,6">{{ info.specialty_short[0] }}</span>
        <span data-id="短特点2" data-range="4,6">{{ info.specialty_short[1] }}</span>
      </div>
      <div class="text3" data-id="公司简称" data-range="8,22">{{ info.company }}</div>

    <div class="text4"><img :src="info.image" alt=""></div>

      <div class="text5" data-id="长特点1" data-range="6,12">{{ info.specialty[0] }}</div>
      <div class="text6" data-id="长特点2" data-range="12,25">{{ info.specialty[1] }}</div>
 

  </div>
</template>
<script>
export default {
  name: 'TUWEN008',
  props: {
    info: Object
  },
}
</script>
